// Tiny, read-only push history list. Pure rendering of the audit log.
export function EhrPushHistory({ history }) {
  if (!history || history.length === 0) return null;
  return (
    <div data-testid="ehr-push-history">
      <p className="text-xs font-semibold text-gray-600 uppercase mb-2">Push History</p>
      <div className="space-y-2 max-h-32 overflow-y-auto">
        {history.map((log, i) => (
          <div key={i} className="text-xs text-gray-600 bg-gray-50 rounded-lg p-2 flex justify-between">
            <span>{log.sections_pushed?.length || 0} sections to {log.ehr_system?.toUpperCase()}</span>
            <span>{new Date(log.created_at).toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
